import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  SellerDashboardStatsEntity,
  SellingMethod
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetSellerDashboard = (
    saleType: MaybeRef<SellingMethod | undefined | null>,
    saleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      saleType = unref(saleType);
saleId = unref(saleId);
      
      return fetchApiInstance<SellerDashboardStatsEntity>(
      {url: `/sellerDashboard/${saleType}/${saleId}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetSellerDashboardQueryKey = (saleType: MaybeRef<SellingMethod | undefined | null>,
    saleId: MaybeRef<string | undefined | null>,) => {
    return ['sellerDashboard',saleType,saleId] as const;
    }

    
export const getApiGetSellerDashboardQueryOptions = <TData = Awaited<ReturnType<typeof apiGetSellerDashboard>>, TError = ErrorType<BackendErrorEntity>>(saleType: MaybeRef<SellingMethod | undefined | null>,
    saleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSellerDashboard>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetSellerDashboardQueryKey(saleType,saleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetSellerDashboard>>> = () => apiGetSellerDashboard(saleType,saleId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(saleType) && unref(saleId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetSellerDashboard>>, TError, TData> 
}

export type ApiGetSellerDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetSellerDashboard>>>
export type ApiGetSellerDashboardQueryError = ErrorType<BackendErrorEntity>



export function useApiGetSellerDashboard<TData = Awaited<ReturnType<typeof apiGetSellerDashboard>>, TError = ErrorType<BackendErrorEntity>>(
 saleType: MaybeRef<SellingMethod | undefined | null>,
    saleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSellerDashboard>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetSellerDashboardQueryOptions(saleType,saleId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



